var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusVectorError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55978 14.218C5.845 14.3823 6.16854 14.4687 6.49789 14.4687C6.82724 14.4687 7.15079 14.3823 7.43601 14.218L12.0609 11.5554C12.3461 11.3911 12.583 11.1549 12.7476 10.8704C12.9123 10.586 12.999 10.2633 12.999 9.93476L12.999 4.60274C12.999 4.27425 12.9123 3.95155 12.7476 3.66707C12.583 3.38259 12.3461 3.14636 12.0609 2.98211L7.43601 0.319491C7.15079 0.155231 6.82724 0.0687536 6.49789 0.0687536C6.16854 0.0687537 5.845 0.155231 5.55978 0.319491L0.937147 2.98211C0.651945 3.14636 0.415107 3.38259 0.250434 3.66707C0.0857605 3.95155 -0.000949996 4.27425 -0.000977425 4.60274L-0.000976959 9.93476C-0.000949472 10.2633 0.0857611 10.586 0.250434 10.8704C0.415108 11.1549 0.651946 11.3911 0.937148 11.5554L5.55978 14.218Z",
    fill: "#ED4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusVectorError);
export default __webpack_public_path__ + "static/media/status_vector_error.93ffecdb463197e28f528cdf1910faf0.svg";
export { ForwardRef as ReactComponent };